import React from "react";
import { AbsoluteFill, useCurrentFrame, interpolate } from "remotion";

// 效果 28: 故障效果
export const GlitchEffect: React.FC = () => {
  const frame = useCurrentFrame();
  const glitchIntensity = Math.random();
  
  const offsetX = glitchIntensity > 0.95 ? (Math.random() - 0.5) * 20 : 0;
  const offsetY = glitchIntensity > 0.95 ? (Math.random() - 0.5) * 10 : 0;
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#0f0f23",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          fontSize: 100,
          fontWeight: "bold",
          color: "white",
          transform: `translate(${offsetX}px, ${offsetY}px)`,
          textShadow: `
            -3px 0 rgba(255, 0, 0, 0.5),
            3px 0 rgba(0, 255, 255, 0.5)
          `,
        }}
      >
        GLITCH
      </div>
    </AbsoluteFill>
  );
};

// 效果 29: 扫描线
export const ScanLines: React.FC = () => {
  const frame = useCurrentFrame();
  const linePosition = interpolate(frame, [0, 60], [0, 720], {
    extrapolateRight: "clamp",
  });
  
  return (
    <AbsoluteFill style={{ backgroundColor: "#0a0a0a" }}>
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: 2,
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          top: linePosition,
          boxShadow: "0 0 20px rgba(255, 255, 255, 0.5)",
        }}
      />
      {Array.from({ length: 20 }, (_, i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            width: "100%",
            height: 1,
            backgroundColor: "rgba(255, 255, 255, 0.05)",
            top: i * 36,
          }}
        />
      ))}
    </AbsoluteFill>
  );
};

// 效果 30: 噪点效果
export const NoiseEffect: React.FC = () => {
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#1a1a2e",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ fontSize: 80, color: "white", fontWeight: "bold" }}>
        NOISE
      </div>
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          background: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
          opacity: 0.3,
        }}
      />
    </AbsoluteFill>
  );
};

// 效果 31: 色彩分离
export const ColorSplit: React.FC = () => {
  const frame = useCurrentFrame();
  const offset = interpolate(
    Math.sin(frame * 0.1),
    [-1, 1],
    [0, 10]
  );
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#000",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ position: "relative" }}>
        <div
          style={{
            fontSize: 100,
            fontWeight: "bold",
            color: "rgba(255, 0, 0, 0.7)",
            position: "absolute",
            left: -offset,
          }}
        >
          SPLIT
        </div>
        <div
          style={{
            fontSize: 100,
            fontWeight: "bold",
            color: "rgba(0, 255, 0, 0.7)",
            position: "absolute",
          }}
        >
          SPLIT
        </div>
        <div
          style={{
            fontSize: 100,
            fontWeight: "bold",
            color: "rgba(0, 0, 255, 0.7)",
            position: "absolute",
            left: offset,
          }}
        >
          SPLIT
        </div>
      </div>
    </AbsoluteFill>
  );
};

// 效果 32: RGB 漂移
export const RGBShift: React.FC = () => {
  const frame = useCurrentFrame();
  const shift = interpolate(
    Math.sin(frame * 0.2),
    [-1, 1],
    [0, 5]
  );
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#0f0f23",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          fontSize: 120,
          fontWeight: "bold",
          color: "white",
          textShadow: `
            ${shift}px 0 rgba(255, 0, 0, 0.8),
            ${-shift}px 0 rgba(0, 0, 255, 0.8)
          `,
        }}
      >
        RGB SHIFT
      </div>
    </AbsoluteFill>
  );
};
